import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

import { BuildToolInvocationStatus, BuildToolInvocationWithDetails } from '@/models/BuildToolInvocation';
import { formatDuration } from '@/utils/commonFormats';
import { secondsToDurationString } from '@/utils/secondsToDurationString';

const elapsedSeconds = (startedAt: string) => {
  const started = new Date(startedAt).getTime();
  if (Number.isNaN(started)) {
    return 0;
  }

  return Math.max(0, Math.round((Date.now() - started) / 1000));
};

type DurationCellProps = {
  invocation: Pick<BuildToolInvocationWithDetails, 'status' | 'startedAt' | 'duration'>;
};

const DurationCell = ({ invocation: { status, startedAt, duration } }: DurationCellProps) => {
  const isRunning = status === BuildToolInvocationStatus.pending;
  const [elapsed, setElapsed] = useState(() => elapsedSeconds(startedAt));

  useInterval(() => setElapsed(elapsedSeconds(startedAt)), isRunning ? 1000 : null);

  const seconds = isRunning ? elapsed : duration;

  return (
    <time dateTime={secondsToDurationString(seconds)} style={{ fontVariantNumeric: 'tabular-nums' }}>
      {formatDuration(seconds)}
    </time>
  );
};

export default DurationCell;
